module.exports = __webpack_public_path__ + "static/media/pipeline-temp.78eea4c2.svg";